import { type ReactNode } from 'react'

import { Header, PrimaryButton, Space, Text } from '@procurify/ui'

import {
  CtaStyled,
  ExcerptStyled,
  HeroImageStyled,
  TitleStyled,
  WhatsNewPromoCardStyled,
} from '../WhatsNewPromoCard/styles/WhatsNewPromoCardStyled'

export interface IPromotionSlideProps {
  /** AP passes its `DiscoverBadge` row; the Pulse slide passes nothing. */
  badge?: ReactNode
  imageSrc: string
  imageAlt: string
  title: ReactNode
  description: ReactNode
  /** Caps the description at two lines, as changelog slides do. Default `true`. */
  isDescriptionClamped?: boolean
  ctaLabel: ReactNode
  onCtaClick: () => void
}

export const PromotionSlide = ({
  badge,
  imageSrc,
  imageAlt,
  title,
  description,
  isDescriptionClamped = true,
  ctaLabel,
  onCtaClick,
}: IPromotionSlideProps) => (
  <WhatsNewPromoCardStyled>
    {badge && (
      <Space direction='horizontal' size='small' align='center'>
        {badge}
      </Space>
    )}

    <HeroImageStyled src={imageSrc} alt={imageAlt} />

    <TitleStyled>
      <Header as='h5'>{title}</Header>
    </TitleStyled>

    {isDescriptionClamped ? (
      <ExcerptStyled>
        <Text>{description}</Text>
      </ExcerptStyled>
    ) : (
      <Text>{description}</Text>
    )}

    <CtaStyled>
      <PrimaryButton type='button' onClick={onCtaClick}>
        {ctaLabel}
      </PrimaryButton>
    </CtaStyled>
  </WhatsNewPromoCardStyled>
)

PromotionSlide.displayName = 'PromotionSlide'
